import React from 'react';
import NoticeWrite from '../NoticeWrite';

function NewWrite() {
  return <NoticeWrite isEdit={false} />;
}

export default NewWrite;
